module.exports = __webpack_public_path__ + "static/img/miles_pictgrid12_960x887.7939e93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_pictgrid12_960x887.jpg
// module id = a+mN
// module chunks = 0